import { useContext } from 'react';
import { ConfigContext } from './config.provider';
import { Configuracao, Hook } from './config.types';

export const useConfig: Hook = () => {
  const config = useContext<Configuracao | null>(ConfigContext);

  if (!config) {
    throw Error('A configuração ainda não está pronta');
  }

  return config;
};
